/* global IS_PREVIEW_PAGE */

export const removeRibbonContainer = () => {
  const { rootDocument, sessionId } = store.getState(); // eslint-disable-line no-undef
  rootDocument.getElementById(`ivoRibbonContainer-${sessionId}`).remove();
};

export const checkCompanionVisibility = () => {
  const { sessionId } = store.getState(); // eslint-disable-line no-undef
  const companions = window.top.document.querySelectorAll('[data-ivo-format=inline]'); // eslint-disable-line no-undef
  const ribbonContaier = window.top.document.getElementById(`ivoRibbonContainer-${sessionId}`); // eslint-disable-line no-undef
  const ribbonHeight = ribbonContaier.getBoundingClientRect().height;

  let companionVisible = false;
  [...companions].forEach((companion) => {
    const bounding = companion.getBoundingClientRect();
    if (!companionVisible) {
      companionVisible = (
        bounding.top <= (window.top.innerHeight || window.top.document.documentElement.clientHeight) &&
        bounding.bottom >= 0
      );
    }
  });
  if (companionVisible) {
    ribbonContaier.style.bottom = `${(0 + ribbonHeight)}px`;
  } else {
    ribbonContaier.style.bottom = '0px';
  }
};

export const resizeRibbonContainer = (sessionId, artboard, safeFrame, canAccessIframe) => {
  const { fluidPlus } = store.getState(); // eslint-disable-line no-undef

  const frameWidth = fluidPlus ? '100%' : `${artboard.viewport.width}px`;

  if (canAccessIframe) {
    const thisWindow = window;
    const iframeParent = thisWindow.frameElement.parentNode;
    const creativeFrame = iframeParent.ownerDocument.getElementById(`ivoRibbonFrame-${sessionId}`);

    creativeFrame.style.width = frameWidth;

    const adjustablePercentage = creativeFrame.clientWidth / artboard.viewport.width;

    creativeFrame.ownerDocument.getElementById(`ivoRibbonContainer-${sessionId}`).style.height = `${(artboard.viewport.height * adjustablePercentage)}px`;
    creativeFrame.style.height = `${(artboard.dimensions.height * adjustablePercentage)}px`;
  }
};

export const createRibbonContainer = (tagInformation, placementId, rootElementName, canAccessIframe, rootBodyElement) => {
  try {
    if (canAccessIframe && !IS_PREVIEW_PAGE) {
      frameElement.style.height = '2px';
      frameElement.height = '2px';
      frameElement.parentNode.style.height = '2px';
    } // eslint-disable-line no-undef

    const thisWindow = window;
    const iframeParent = thisWindow.frameElement.parentNode;
    const anchorElement = iframeParent.ownerDocument.body;

    const ribbonContainer = document.createElement('div'); // eslint-disable-line no-undef
    ribbonContainer.id = `ivoRibbonContainer-${tagInformation.sessionId}`;
    ribbonContainer.className = 'ivo-ad ribbon root';
    ribbonContainer.style.cssText = 'position: fixed; left: 0; bottom: 0; width: 100%; min-width: 0px; height:auto; overflow: hidden; z-index:9999;';
    ribbonContainer.style.transition = 'top 0.2s, bottom 0.2s';

    anchorElement.appendChild(ribbonContainer); // eslint-disable-line no-undef

    const iframe = document.createElement('iframe'); // eslint-disable-line no-undef
    iframe.id = `ivoRibbonFrame-${tagInformation.sessionId}`;
    iframe.style.cssText = 'border:0; margin:auto;';
    iframe.width = '100%';
    iframe.height = '50px';
    iframe.scrolling = 'no';

    ribbonContainer.appendChild(iframe);

    return iframe;
  } catch (e) {
    console.log('ivo : error rendering ribbon container');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/ribbonContainer.js